import { SupportedLocales } from '@/models/localization.model';

export enum MetaTagsFiltersFields {
  SLUG = 'slug',
}

export enum MetaTagsFormFieldsNames {
  SLUG = 'slug',
  INDEX = 'index',
  TITLE = 'seo_title',
  LOCALE = 'locale',
  DESCRIPTION = 'seo_description',
  KEYWORDS = 'seo_keywords',
  TEXT = 'seo_text',
}

export type TMetaTagsFormValues = {
  [MetaTagsFormFieldsNames.SLUG]: string;
  [MetaTagsFormFieldsNames.INDEX]: boolean;
  [MetaTagsFormFieldsNames.LOCALE]?: Record<
    SupportedLocales,
    {
      [MetaTagsFormFieldsNames.TITLE]?: string;
      [MetaTagsFormFieldsNames.DESCRIPTION]?: string;
      [MetaTagsFormFieldsNames.KEYWORDS]?: string[];
      [MetaTagsFormFieldsNames.TEXT]?: string;
    }
  >;
};

export type TGetRedirectsQuery = {
  [MetaTagsFiltersFields.SLUG]?: string;
};
